import { Box, Typography } from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ApplicationStatus,
  CommonOrCommonRetirementFlug,
  FacilityKind,
} from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_APP016_Request } from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  funStatusBodyList,
  fundownloadBodyList,
} from "./../SCRW050003/hooks/useHooks";
import "./_style.scss";
import { httpAPI_APP016, httpAPI_CON023 } from "./api/request";
import {
  fakeTableList,
  fakeTableListSecond,
  headList,
  infoHeadTitleList,
  schema,
  smeGratuitySession,
} from "./parts";
import _ from "lodash";
import { changeAmountFormat } from "../../utils/useTools";

/**
 * SCRW050003_契約解除（中退共済契約締結）入力内容確認
 * @return SCRW050003_契約解除（中退共済契約締結）入力内容確認
 */

const SCRW050003 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [smeGratuitySessionTableList, setsmeGratuitySessionTableList] =
    useState<any>([]);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [stateTableListSecond, setStateTableListSecond] = useState<any>([]);

  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [statusBodyList, setStatusBodyList] = useState<any>([]);
  const [status, setStatus] = useState<string>();
  const [approvalDate, setApprovalDate] = useState<string>();
  const [symbolNo, setSymbolNo] = useState<string>();
  const [workFlow, setWorkFlow] = useState(false);
  const location = useLocation();
  const applyId = location?.state?.applyId ?? businessState?.job_03?.applyId;

  const fakeSmeGratuitySessionRef = useRef(_.cloneDeep(smeGratuitySession));
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const stateFakeTableListSecondRef = useRef(_.cloneDeep(fakeTableListSecond));
  const fakeSmeGratuitySession = fakeSmeGratuitySessionRef.current;
  const stateFakeTableList = stateFakeTableListRef.current;
  const stateFakeTableListSecond = stateFakeTableListSecondRef.current;

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpAPI_CON023({
        applyId,
        contractorNo: businessState?.common?.contractorNo,
      });

      let resArr = stateFakeTableList;
      let resArrSecond = stateFakeTableListSecond;
      let resArrSmeGratuitySessionTableList = fakeSmeGratuitySession;

      if (res.resultCd === "I0000") {
        setStatus(res.latestApplyStatus!);
        resArr.find((item) => item.keyword === "contractDate")!.text =
          res.contractDate;

        resArr.find((item) => item.keyword === "contractNo")!.text =
          res.contractNo;

        resArr.find((item) => item.keyword === "contractReason")!.text =
          res.contractReason;

        resArr.find((item) => item.keyword === "remark")!.text = res.remark;

        let employeeStatusCheckbox = resArrSecond.find(
          (item) => item.keyword === "employeeStatusCheckbox"
        )!;

        employeeStatusCheckbox.node = (
          <TkCheckbox
            data-testid="employeeStatusCheckbox"
            label="はい"
            checked={true}
            disabled={true}
          />
        );

        let facilitySituationTable = resArrSecond.find(
          (item) => item.keyword === "facilitySituationTable"
        )!;

        const infoBodyList = funInfoBodyList(
          res.facilityList,
          res.contractDate
        );
        facilitySituationTable.node = (
          <TkDataTable
            bodyList={infoBodyList}
            defaultRowsPerPage={5}
            headList={infoHeadTitleList}
            pagin
          />
        );

        const downloadBodyList = fundownloadBodyList(res);

        let smeGratuitySession = resArrSmeGratuitySessionTableList.find(
          (item) => item.keyword === "SMEGratuitySession"
        )!;

        smeGratuitySession.node = (
          <TkTableWithNoLine
            bodyList={downloadBodyList}
            headList={[
              { align: "left", headTitle: "帳票名" },
              {
                align: "left",
                headTitle: "記号番号",
              },
              {
                align: "left",
                headTitle: "決裁日",
              },
            ]}
          />
        );

        const statusList = funStatusBodyList(res.statusList);
        setStatusBodyList(statusList);
        setStateTableList([...resArr]);
        setStateTableListSecond([...resArrSecond]);
        setsmeGratuitySessionTableList([...resArrSmeGratuitySessionTableList]);
        setApprovalDate(res.approvalDate);
        setSymbolNo(res.symbolNo?.toString());
        setState({
          ...state,
          errorMsgId: "",
        });
        setBusinessState({
          ...businessState,
          job_03: {
            ...businessState?.job_03,
            applyId,
          },
        });

        const wfFlg =
          res.latestApplyStatus !== "00" && res.latestApplyStatus !== "16";
        setWorkFlow(wfFlg);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (num: string, formData?: any) => {
    let data: IAPI_APP016_Request = {};
    data.applyEvent = num;
    data.reason = memoData;
    data.applyId = applyId;
    data.screenId = "SCRW050003"; //画面ID

    if (memoCheck) {
      data.inquiryCode = "1";
    }

    if (formData?.symbolNumber !== undefined) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData?.symbolNumberType) +
        "第" +
        (formData.symbolNumber ?? "") +
        "号";
      data.decisionDate = formData.settlementDate;
    }

    return data;
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : btnName === "郵送"
        ? "11"
        : btnName === "取下げ"
        ? "13"
        : "";

    if (num === "") {
      return;
    }

    if (num === "3") {
      setIsOpen(true);
      return;
    }

    let reqData: IAPI_APP016_Request = makeHttpObj(num);

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj("3", formData);
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };

  /**
   * 施設一覧テーブルを作成する
   * @param res
   * @returns infoBodyList
   */
  function funInfoBodyList(res: any, cancelDate: any) {
    const infoBodyList: any = res?.map((item: any) => [
      {
        id: item.facilityNo,
      },
      {
        children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
        forSort: item.facilityNo,
      },
      {
        children: FacilityKind[item.facilityKind as keyof typeof FacilityKind],
        forSort: item.facilityKind,
      },
      {
        children: changeAmountFormat(item.joinStaffNum),
        forSort: item.joinStaffNum,
        align: "right",
      },
      {
        children: (
          <Box className="displayButton">
            <TkButton
              data-testid="SCRW050003DisplayButton"
              onClick={() => handleDisplay(item, cancelDate)}
            >
              表示
            </TkButton>
          </Box>
        ),
      },
      {
        algin: "left",
        children: (
          <Box className="resisterButton">
            <TkButton
              data-testid="SCRW050003ResisterButton"
              onClick={() => handleResister(item.facilityNo)}
            >
              確認
            </TkButton>
            <Box className="resisterButtonText">
              <Typography>
                {(cancelDate !== null &&
                cancelDate !== undefined &&
                item.threeMonthsRetireCertificate === item.threeMonthsRetire
                  ? "完了"
                  : cancelDate === null ||
                    cancelDate === undefined ||
                    item.threeMonthsRetireCertificate === 0
                  ? "未登録"
                  : "登録中") +
                  (cancelDate === null || cancelDate === undefined
                    ? "(-人/-人　登録済)"
                    : "(" +
                      (item.threeMonthsRetireCertificate ?? "") +
                      "人/" +
                      (item.threeMonthsRetire ?? "") +
                      "人　登録済" +
                      ")")}
              </Typography>
            </Box>
          </Box>
        ),
      },
    ]);

    return infoBodyList ?? [];
  }

  //表示ボタン用イベント
  const handleDisplay = (facility: any, contractDate: any) => {
    const stated: any = {
      facilityNo: facility.facilityNo,
      facilityName: facility.facilityName,
      kindCd: facility.facilityKind,
      cancelDate: contractDate,
      applyId,
    };

    navigate("/SCRC050111", { state: stated });
  };

  //登録ボタン用イベント
  const handleResister = (facilityNo: any) => {
    navigate("/SCRC050115", { state: { facilityNo: facilityNo } });
  };

  return (
    <Box data-testid="SCRW050003PageForTest" className="SCRW050003">
      {workFlow && (
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType="JOB-03"
          applicationStatus={status as keyof typeof ApplicationStatus}
        />
      )}
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW050003_01}</TkInfoManual>

      <TkContractorAndNumberLine
        name="契約者（法人）名"
        no={
          (businessState.common?.contractorNo ?? "") +
          ":" +
          (businessState.common?.contractorName ?? "")
        }
      />

      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        showButton={false}
      />
      <TkFakeTable
        list={stateTableListSecond}
        ruleSchema={schema}
        showButton={false}
      />
      <TkMemo
        showTable={true}
        headList={headList}
        bodyList={statusBodyList}
        onChange={onChange}
      ></TkMemo>
      <TkFakeTable
        list={smeGratuitySessionTableList}
        ruleSchema={schema}
        showButton={false}
      />

      <Box className="btn">
        <TkBackButton mr />
        {workFlow ? (
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={status as keyof typeof ApplicationStatus}
            onClick={btnEvent}
          />
        ) : (
          <TkButton onClick={() => btnEvent("取下げ")}>取下げ</TkButton>
        )}
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW050003PageForDialog"
        open={isOpen}
        onSuccess={handleSave}
        onClose={setOpen}
        wantToSetValue={{
          symbolNumber: symbolNo,
          settlementDate: approvalDate,
        }}
      />
    </Box>
  );
};

export default SCRW050003;
